import { getAPI, postAPI } from './api-service'
import { optionsForSurvey } from './service-helper'

export const loadGroupResultsForSurveyAPI = async ({
  surveyName,
  groupName,
  aggregate,
  oldSurveys,
  onlyReturnOldSurveys,
  questionName,
  apiVersion = 'v2',
  selectedAttributeSegment
}) => {
  const path =
    selectedAttributeSegment && selectedAttributeSegment.name !== 'all'
      ? `/${apiVersion}/surveys/${surveyName}/groups/${groupName}/attributes/${selectedAttributeSegment.attributeName}/segments/${selectedAttributeSegment.segmentName}`
      : `/${apiVersion}/surveys/${surveyName}/groups/${groupName}`

  return await getAPI(
    'ResultsAPI',
    path,
    optionsForSurvey({
      aggregate,
      oldSurveys,
      onlyReturnOldSurveys,
      questionName
    })
  )
}

export const loadGroupResultsPerPersonAPI = async ({
  surveyName,
  groupName,
  statItemName,
  aggregate,
  oldSurveys,
  onlyReturnOldSurveys,
  questionName,
  selectedAttributeSegment
  // apiVersion = 'v2'
}) => {
  const path = selectedAttributeSegment
    ? `/surveys/${surveyName}/groups/${groupName}/peruser/${statItemName}/attributes/${selectedAttributeSegment.attributeName}/segments/${selectedAttributeSegment.segmentName}`
    : `/surveys/${surveyName}/groups/${groupName}/peruser/${statItemName}`
  return await getAPI(
    'ResultsAPI',
    path,
    optionsForSurvey({
      aggregate,
      oldSurveys,
      onlyReturnOldSurveys,
      questionName
    })
  )
}

export const loadQuestionResponsesForSurveyAPI = async ({
  surveyName,
  groupName,
  categoryName,
  questionName,
  aggregate,
  selectedAttributeSegment
}) => {
  const path = selectedAttributeSegment
    ? `/surveys/${surveyName}/groups/${groupName}/categories/${categoryName}/questions/${questionName}/attributes/${selectedAttributeSegment.attributeName}/segments/${selectedAttributeSegment.segmentName}`
    : `/surveys/${surveyName}/${groupName}/${categoryName}/${questionName}`
  return await getAPI('ResultsAPI', path, {
    ...optionsForSurvey({ aggregate })
  })
}

export const sendRealtimeMessageAPI = ({
  connectionId,
  surveyName,
  groupName,
  messages,
  aggregate
}) => {
  const messagesSize = JSON.stringify(messages).length
  if (messagesSize > 262000 * 100) {
    return Promise.reject(new Error('Too much data.'))
  }
  const path = `/surveys/${surveyName}/groups/${groupName}/messages`
  const providerName = messages[0].modelName
  const body = {
    connectionId,
    providerName,
    messages
  }
  return postAPI('ResultsAPI', path, {
    ...optionsForSurvey({
      aggregate
    }),
    body
  })
}

export const requestExportForSurveyAPI = ({
  groupTitle,
  groupName,
  surveyName,
  surveyNames = null, // for history
  email,
  type,
  format,
  filter,
  options
}) => {
  const path =
    groupName === 'all'
      ? `/surveys/${surveyName}/groups/exports`
      : `/surveys/${surveyName}/groups/${groupName}/exports`
  const body = {
    groupTitle,
    email,
    type,
    format,
    filter,
    options
  }
  if (surveyNames && surveyNames.length > 0) {
    body.surveyNames = surveyNames.concat(surveyName) // current susvey must be included
  }
  if (groupName === 'all') {
    delete body.groupTitle
  }
  return postAPI('ResultsAPI', path, {
    body
  })
}
